import * as React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Install from './Install';
import DemoLinkGenerator from './iframes/DemoLinkGenerator';
import DemoAccess from './pages/DemoAccess';
import DemoAccessSales from './pages/DemoAccessSales';
import TicketList from './iframes/TicketList';
import OpportunityResynch from './iframes/OpportunityResynch';
import CompanyLink from './iframes/CompanyLink';
import CompanyCompareUpdate from './iframes/CompanyCompareUpdate';
import ContactLink from './iframes/ContactLink';
import ContactCompareUpdate from './iframes/ContactCompareUpdate';
import Exemption from './iframes/Exemption';
import LabSimCompanyLink from './iframes/LabSimCompanyLink';
import LabSimUserLink from './iframes/LabSimUserLink';
import LabSimUserProducts from './iframes/LabSimUserProducts';

import DemoTestDev from './pages/DemoTestDev';
import DemoTestLive from './pages/DemoTestLive';
import DemoTestLocalHost from './pages/DemoTestLocalHost';

function App() {
  return (
      <div className="App">
          <BrowserRouter>
              <Switch>
                  <Route exact path="/" component={Install} />
                  <Route path="/iframes/DemoLinkGenerator" component={DemoLinkGenerator} />
                  <Route path="/pages/DemoAccess" component={DemoAccess} />
                  {/*For backwards compatibility with old email links, we need to include route with an .aspx extension. */}
                  <Route path="/pages/DemoAccess.aspx" component={DemoAccess} />
                  <Route path="/pages/DemoAccessSales" component={DemoAccessSales} />
                  <Route path="/iframes/TicketList" component={TicketList} />
                  {/*<Route path="/iframes/OpportunityResynch" component={OpportunityResynch} />*/}
                  {/*<Route path="/iframes/CompanyLink" component={CompanyLink} />*/}
                  {/*<Route path="/iframes/CompanyCompareUpdate" component={CompanyCompareUpdate} />*/}
                  {/*<Route path="/iframes/ContactLink" component={ContactLink} />*/}
                  {/*<Route path="/iframes/ContactCompareUpdate" component={ContactCompareUpdate} />*/}
                  {/*<Route path="/iframes/Exemption" component={Exemption} />*/}
                  <Route path="/iframes/LabSimCompanyLink" component={LabSimCompanyLink} />
                  <Route path="/iframes/LabSimUserLink" component={LabSimUserLink} />
                  <Route path="/iframes/LabSimUserProducts" component={LabSimUserProducts} />

                  <Route path="/pages/DemoTestDev" component={DemoTestDev} />
                  <Route path="/pages/DemoTestLive" component={DemoTestLive} />
                  <Route path="/pages/DemoTestLocalHost" component={DemoTestLocalHost} />
              </Switch>
          </BrowserRouter>
    </div>
  );
}

export default App;
